import { render, staticRenderFns } from "./selectMaterial.vue?vue&type=template&id=724f8d4e&scoped=true"
import script from "./selectMaterial.vue?vue&type=script&lang=js"
export * from "./selectMaterial.vue?vue&type=script&lang=js"
import style0 from "./selectMaterial.vue?vue&type=style&index=0&id=724f8d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f8d4e",
  null
  
)

export default component.exports